import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import ConfirmModal from './modals/ConfirmModal';

const Sidebar = () => {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    authService.logout();
    sessionStorage.clear();
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className="bg-gray-800 text-white w-64 min-h-screen p-4">
      <div className="mb-8">
        <h1 className="text-2xl font-bold">Xervix Admin</h1>
      </div>

      <nav>
        <ul className="space-y-2 w-full">
          <li className="w-full">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Dashboard
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/empresas"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Empresas
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/usuarios"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Usuarios
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/categorias-servicios"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Categorías y Servicios
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/ciudades"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Ciudades
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/servicios"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Solicitudes de Servicios
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/leads"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Leads Empresas
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/leads_partnes"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Leads Socios
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/promociones"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Promociones
            </NavLink>
          </li>
          <li className="w-full">
            <NavLink
              to="/company-providers"
              className={({ isActive }) =>
                `block p-2 rounded-lg transition-colors ${isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
                }`
              }
            >
              Patners Providers
            </NavLink>
          </li>
          <li className="w-full">
            <button
              onClick={handleLogout}
              className="w-full text-left block p-2 rounded-lg transition-colors text-gray-300 hover:bg-red-600 hover:text-white"
            >
              Cerrar Sesión
            </button>
          </li>
        </ul>
      </nav>

      <ConfirmModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={confirmLogout}
        title="Cerrar Sesión"
        message="¿Está seguro que desea cerrar sesión? Se eliminará toda la información almacenada."
        confirmText="Sí, cerrar sesión"
        cancelText="Cancelar"
        confirmButtonColor="bg-red-600 hover:bg-red-700"
      />
    </div>
  );
};

export default Sidebar;
